import Vue from 'vue'
import App from './app.vue'
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
//import 'swiper/swiper-bundle.css'
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
  Navigation,
} from 'swiper/swiper.esm'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
import VueWaypoint from 'vue-waypoint'
import i18n from "../../i18n";
import GLOBAL from '@/utils/global.js'
Vue.prototype.GLOBAL = GLOBAL

Vue.use(VueWaypoint)

Vue.use(BootstrapVue)
SwiperClass.use([Pagination, Mousewheel, Autoplay, Navigation])
Vue.use(getAwesomeSwiper(SwiperClass))

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  i18n
}).$mount('#app')
